import axios from "axios";
import { localStorageInstance } from "../utils/localStorage";

const API_URL =   process.env.REACT_APP_PLANNER_BASE_URL;

const frontEndURL = `${window.location.protocol}//${window.location.hostname}/my-task`;
// const frontEndURL = "http://localhost:3000/my-task";



export const apiGoogleLogin = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/api/v1/users/google/login`,
      {
        params: {
          origin:`${window.location.protocol}//${window.location.hostname}`,
        },
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    const { auth_url } = response.data;
     window.location.href = auth_url;
  } catch (error) {
    console.error("Failed to get Google auth URL:", error);
  }
}

export const apiGoogleCallback = async (code,scope) => {
     return axios.get(
       `${API_URL}/api/v1/users/google/callback?state=some-random-state&redirect_uri=${frontEndURL}&code=${code}&scope=${scope}&authuser=0&prompt=none`
     );
}

export const refreshPlannerToken = async () => {
  const refreshToken = localStorageInstance.getItem("planner_refresh_token");
  
  if (!refreshToken) {
    throw new Error("No refresh token available");
  }
  
  try {
    const response = await axios.post(`${API_URL}/api/v1/users/refresh`, {}, {
      headers: {
        'Authorization': `Bearer ${refreshToken}`
      }
    });
    
    // Save the new tokens
    localStorageInstance.setItem({
      key: "planner_access_token",
      value: response.data.access_token,
    });
    
    if (response.data.refresh_token) {
      localStorageInstance.setItem({
        key: "planner_refresh_token",
        value: response.data.refresh_token,
      });
    }
    
    return response.data.access_token;
  } catch (error) {
    console.error("Failed to refresh token:", error);
    // If refresh fails, redirect to login
   
    throw error;
  }
}